import { render, staticRenderFns } from "./NotificationListItemTitle.vue?vue&type=template&id=d90d63dc&scoped=true"
import script from "./NotificationListItemTitle.vue?vue&type=script&lang=js"
export * from "./NotificationListItemTitle.vue?vue&type=script&lang=js"
import style0 from "./NotificationListItemTitle.vue?vue&type=style&index=0&id=d90d63dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90d63dc",
  null
  
)

export default component.exports